export const RemoveIcon = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 16A8 8 0 108 0a8 8 0 000 16zm2.828-9.414a1 1 0 10-1.414-1.414L8 6.586 6.586 5.172a1 1 0 10-1.414 1.414L6.586 8 5.172 9.414a1 1 0 101.414 1.414L8 9.414l1.414 1.414a1 1 0 101.414-1.414L9.414 8l1.414-1.414z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
